function formatNorthAmericanPhone(digits, withCountryCode = false) {
    const safeDigits = digits.slice(0, withCountryCode ? 11 : 10)
    const countryCode = withCountryCode ? safeDigits.slice(0, 1) : ''
    const localDigits = withCountryCode ? safeDigits.slice(1) : safeDigits
    const area = localDigits.slice(0, 3)
    const prefix = localDigits.slice(3, 6)
    const line = localDigits.slice(6, 10)

    let formatted = ''

    if (withCountryCode && countryCode) {
        formatted += `+${countryCode}`
    }

    if (area) {
        formatted += `${formatted ? ' ' : ''}(${area}`

        if (area.length === 3) {
            formatted += ')'
        }
    }

    if (prefix) {
        formatted += `${area ? ' ' : ''}${prefix}`
    }

    if (line) {
        formatted += `-${line}`
    }

    return formatted
}

export function formatPhoneInput(value) {
    if (!value) {
        return ''
    }

    const trimmedValue = String(value).trim()
    const hasPlusPrefix = trimmedValue.startsWith('+')
    const digits = trimmedValue.replace(/\D+/g, '')

    if (!digits) {
        return hasPlusPrefix ? '+' : ''
    }

    if (hasPlusPrefix) {
        if (digits.startsWith('1')) {
            return formatNorthAmericanPhone(digits, true)
        }

        return `+${digits.slice(0, 15)}`
    }

    if (digits.length <= 10) {
        return formatNorthAmericanPhone(digits)
    }

    if (digits.length === 11 && digits.startsWith('1')) {
        return formatNorthAmericanPhone(digits, true)
    }

    return digits.slice(0, 15)
}

export default formatPhoneInput
